import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { ImPointRight } from "react-icons/im";
import { useTranslation } from "../../i18n";
import programmingJavaPdf from "../../Assets/Programming In Java.pdf";
import problemSolvingCPdf from "../../Assets/Problem Solving Through Programming in C.pdf";
import jlptN5Certificate from "../../Assets/JAPANESE_N5.jpeg";

const CERTIFICATE_FILES = {
  "java-nptel": programmingJavaPdf,
  "c-nptel": problemSolvingCPdf,
  "jlpt-n5": jlptN5Certificate,
};

function Certifications() {
  const { t } = useTranslation();
  const items = t("certifications.items");

  return (
    <Row className="certifications-section">
      <Col xs={12} md={10} lg={8} className="mx-auto">
        <ul className="certifications-list">
          {Array.isArray(items) &&
            items.map((cert) => {
              const fileUrl = CERTIFICATE_FILES[cert.id];

              return (
                <li key={cert.id} className="certification-item">
                  <ImPointRight className="certification-icon" />
                  <div className="certification-content">
                    <span className="certification-title purple">
                      {cert.title}
                    </span>
                    {cert.issuer && (
                      <span className="certification-meta">
                        {" "}
                        – {cert.issuer}
                        {cert.period && ` (${cert.period})`}
                      </span>
                    )}
                    {cert.detail && (
                      <span className="certification-meta">
                        {" "}
                        – {cert.detail} ({cert.period})
                      </span>
                    )}
                    {!cert.issuer && !cert.detail && cert.period && (
                      <span className="certification-meta">
                        {" "}
                        ({cert.period})
                      </span>
                    )}
                  </div>
                  {fileUrl && (
                    <Button
                      variant="outline-light"
                      size="sm"
                      className="certification-view-btn"
                      href={fileUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t("certifications.view")}
                    </Button>
                  )}
                </li>
              );
            })}
        </ul>
      </Col>
    </Row>
  );
}

export default Certifications;
